import { CapTableRail } from '@dealstack/shared/lib/generated';
import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import { downloadCapHoldingsJsonQuery } from '@dealstack/frontend/app/services/CapTableData.service.ts';
import { downloadFileFromBlob } from '@dealstack/frontend/shared/files/downloadFile.ts';
import { CapHeaderContext } from '@dealstack/frontend/app/pages/Project/Cap/common/CapPageHeader/useCapPageHeaderController.tsx';
import { formatAsOfFilterDateOnly } from '@dealstack/frontend/shared/utils/utc.ts';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';

const useDownloadCapTableJson = ({ dealId, rail }: { dealId: string; rail: CapTableRail }) => {
	const { filterDate } = useContext(CapHeaderContext);

	const downloadJsonRequest = useMutation({
		mutationFn: downloadCapHoldingsJsonQuery,
	});

	const onDownloadCapTableToJson = async () => {
		const holdingsDate = formatAsOfFilterDateOnly(filterDate);

		try {
			const payload = await downloadJsonRequest.mutateAsync({
				dealId,
				filterDate: holdingsDate,
				rail,
			});
			const blob = new Blob([JSON.stringify(payload, null, 2)]);
			downloadFileFromBlob(blob, `${dealId}_${new Date().toISOString()}.json`);
		} catch {
			showToastV2({
				state: 'error',
				message: 'Failed to download JSON export',
			});
		}
	};

	return { onDownloadCapTableToJson, isDownloadingJson: downloadJsonRequest.isPending };
};

export { useDownloadCapTableJson };
